module.exports = __webpack_public_path__ + "img/you_can_heal_your_life.23268c1f.jpg";